var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "13px",
    viewBox: "0 0 9 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "314D73B4-F4D1-4F99-A185-5FE6323EDEC7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.548060 0 0 0 0 0.302293 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-2",
    points: "1.83490213e-16 0 9 0 9 4.95225135 1.83490213e-16 4.95225135"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sort",
    transform: "translate(-98.000000, -1841.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.000000, 1841.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.50499788,4.95166477 C3.18408867,4.95166477 1.86314189,4.95204039 0.542232671,4.95072571 C0.468160187,4.95065059 0.390631988,4.94828418 0.320616212,4.92732452 C0.0156869904,4.83601103 -0.0965861612,4.47398739 0.0994504993,4.22416179 C0.131077797,4.18385764 0.169428713,4.14862438 0.205826399,4.1122267 C1.50742869,2.8104366 2.80910611,1.50872162 4.11082108,0.207081764 C4.38772897,-0.0697885603 4.61407825,-0.0691500044 4.8930145,0.209748674 C6.19149913,1.5080455 7.48983352,2.80645501 8.78813034,4.10497721 C8.82452803,4.1413749 8.86299163,4.17649547 8.89454381,4.2169123 C9.00422517,4.35746972 9.03209626,4.51342761 8.96031506,4.67840041 C8.88887193,4.84258439 8.75762991,4.93145635 8.58011137,4.94937348 C8.5290269,4.95451949 8.47711606,4.95158964 8.42561841,4.95158964 C7.11875742,4.95166477 5.81185887,4.95166477 4.50499788,4.95166477",
    id: "Fill-1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 7.650245)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49803387,0.000618477105 C5.80959012,0.000618477105 7.12114637,0.000618477105 8.43270262,0.000656039216 C8.47954257,0.000656039216 8.52664546,-0.00163524959 8.57318492,0.00234633424 C8.75119176,0.0174838652 8.88352308,0.104214781 8.95725751,0.267459718 C9.03388422,0.437090214 9.00511164,0.596729188 8.8899462,0.740554514 C8.85786816,0.780595725 8.81962993,0.815791423 8.78323225,0.852226671 C7.48827845,2.14740584 6.19324953,3.44247233 4.89810792,4.73750125 C4.61252318,5.02304842 4.38932912,5.02372454 4.10584786,4.74024328 C2.80743835,3.44190889 1.5090664,2.14349938 0.210694449,0.845127432 C0.187518626,0.821951609 0.16392962,0.799151408 0.141429915,0.775299467 C0.00275059916,0.628318924 -0.0409341366,0.458913801 0.041740071,0.27159155 C0.121221499,0.0914812251 0.268277166,0.00185802679 0.464989945,0.001257033 C0.942780004,-0.000207889351 1.42057006,0.000656039216 1.89832256,0.000618477105 C2.76491804,0.000580914993 3.63147595,0.000618477105 4.49803387,0.000618477105",
    id: "Fill-3",
    fill: "#000000",
    mask: "url(#mask-3)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.88d4e93946444cdc1b6a36e3d031d057.svg";
export { ForwardRef as ReactComponent };